import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_menu_ext_RowClass} from '../../../dbschema';

export class MenuExtensionContainerModel extends BaseContainerModel {

  bl_cms_menu_ext: bl_cms_menu_ext_RowClass = new bl_cms_menu_ext_RowClass();
}
